<script>
  export let navlists = [];
</script>
<!------------------------------------------->
<!----------------MARKUP----------------------->
<!------------------------------------------->
<section id="navbar">
  <nav class="navbar main-bgcolor navbar-expand-md navbar-dark" id="top">
    <a class="navbar-brand company_brand" href="#banner">
      <img src="images/n3t-light.svg" alt="N3T web agency" width="80"/>
    </a>
    <div class="navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ml-auto">
        {#each navlists as list}
          <li class="nav-item">
            <a class="nav-link light-color" href={list.url}>{list.label}</a>
          </li>
        {/each}
      </ul>
    </div>
  </nav>
</section>
<!------------------------------------------->
<!----------------STYLE----------------------->
<!------------------------------------------->
<style>
  #navbar {
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .navbar {
    padding: 0 20px !important;
    line-height: 1;
  }

  .navbar-nav {
    flex-direction: row;
    justify-content: flex-end;
  }

  .navbar-collapse {
    flex-basis: auto;
  }

  .navbar-nav li {
    padding: 0 0 0 20px;
  }

  .navbar-nav li a {
    font-weight: 600;
    text-transform: uppercase;
    float: right;
    text-align: left;
    font-size: 16px;
  }
</style>